(()=>{
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const money=cents=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency:window.FMX.currency||'USD'}).format((Number(cents)||0)/100)}catch(e){return '$'+((Number(cents)||0)/100).toFixed(2)}};
  const lock=on=>document.documentElement.style.overflow=on?'hidden':'';

  // Mobile menu
  const menu=$('[data-mobile-menu]'), menuOpen=$('[data-menu-open]'), menuClose=$('[data-menu-close]');
  const openMenu=()=>{if(!menu)return;menu.hidden=false;menuOpen?.setAttribute('aria-expanded','true');lock(true)};
  const closeMenu=()=>{if(!menu)return;menu.hidden=true;menuOpen?.setAttribute('aria-expanded','false');lock(false)};
  menuOpen?.addEventListener('click',openMenu); menuClose?.addEventListener('click',closeMenu); menu?.addEventListener('click',e=>{if(e.target===menu)closeMenu()});

  // Search overlay. Predictive results are isolated in fmx-search.js.
  const overlay=$('[data-search-overlay]'), searchOpen=$('[data-search-open]'), searchClose=$('[data-search-close]'), predictiveInput=$('[data-predictive-input]');
  const openSearch=()=>{if(!overlay)return;overlay.hidden=false;searchOpen?.setAttribute('aria-expanded','true');lock(true);setTimeout(()=>predictiveInput?.focus(),30);overlay.dispatchEvent(new Event('fmx-search-open'))};
  const closeSearch=()=>{if(!overlay)return;overlay.hidden=true;searchOpen?.setAttribute('aria-expanded','false');lock(false)};
  searchOpen?.addEventListener('click',openSearch);searchClose?.addEventListener('click',closeSearch);overlay?.addEventListener('click',e=>{if(e.target===overlay)closeSearch()});

  // Carousel drag / arrows. Preserve normal product/link clicks.
  $$('[data-carousel-track]').forEach(track=>{
    let pointerDown=false;
    let dragging=false;
    let startX=0;
    let startScroll=0;
    let activePointerId=null;
    let suppressClickUntil=0;
    const threshold=8;

    track.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      pointerDown=true;
      dragging=false;
      activePointerId=e.pointerId;
      startX=e.clientX;
      startScroll=track.scrollLeft;
    });

    track.addEventListener('pointermove',e=>{
      if(!pointerDown||e.pointerId!==activePointerId)return;
      const delta=e.clientX-startX;
      if(!dragging&&Math.abs(delta)>threshold){
        dragging=true;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(e.pointerId);
      }
      if(dragging){
        e.preventDefault();
        track.scrollLeft=startScroll-delta;
      }
    });

    const finish=e=>{
      if(e&&activePointerId!==null&&e.pointerId!==undefined&&e.pointerId!==activePointerId)return;
      if(dragging)suppressClickUntil=performance.now()+220;
      pointerDown=false;
      dragging=false;
      activePointerId=null;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup',finish);
    track.addEventListener('pointercancel',finish);
    track.addEventListener('lostpointercapture',finish);
    track.addEventListener('dragstart',e=>e.preventDefault());
    track.addEventListener('click',e=>{
      if(performance.now()<suppressClickUntil){
        e.preventDefault();
        e.stopPropagation();
      }
    },true);
  });
  $$('[data-carousel]').forEach(wrap=>{const track=$('[data-carousel-track]',wrap);$('[data-carousel-prev]',wrap)?.addEventListener('click',()=>track?.scrollBy({left:-(track.clientWidth*.78),behavior:'smooth'}));$('[data-carousel-next]',wrap)?.addEventListener('click',()=>track?.scrollBy({left:track.clientWidth*.78,behavior:'smooth'}))});

  // Product gallery — adaptive height, never crop product media
  const gallery=$('[data-gallery-track]');
  if(gallery){const slides=$$('.product-media',gallery), thumbs=$$('[data-gallery-thumb]');let index=0,resizeTimer;
    const syncGalleryHeight=i=>{
      const slide=slides[i]; if(!slide)return;
      let ratio=Number(slide.dataset.mediaAspect||0);
      const img=$('img',slide);
      if((!ratio||!Number.isFinite(ratio))&&img?.naturalWidth&&img?.naturalHeight)ratio=img.naturalWidth/img.naturalHeight;
      if(!ratio||!Number.isFinite(ratio)||ratio<=0)ratio=16/9;
      const width=gallery.clientWidth||gallery.parentElement?.clientWidth||700;
      const mobile=window.matchMedia('(max-width:800px)').matches;
      const minH=mobile?280:360;
      const hardMax=mobile?520:680;
      const viewportMax=window.innerHeight*(mobile?.70:.68);
      const maxH=Math.min(hardMax,viewportMax);
      const desired=width/ratio;
      const target=Math.round(Math.max(minH,Math.min(maxH,desired)));
      gallery.style.setProperty('--fmx-gallery-height',`${target}px`);
    };
    const go=i=>{index=Math.max(0,Math.min(slides.length-1,i));syncGalleryHeight(index);slides[index]?.scrollIntoView({behavior:'smooth',inline:'start',block:'nearest'});thumbs.forEach((b,n)=>b.classList.toggle('is-active',n===index))};
    $('[data-gallery-prev]')?.addEventListener('click',()=>go(index-1));$('[data-gallery-next]')?.addEventListener('click',()=>go(index+1));thumbs.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.galleryThumb))));
    let down=false,x=0,sl=0;gallery.addEventListener('pointerdown',e=>{down=true;x=e.clientX;sl=gallery.scrollLeft;gallery.setPointerCapture?.(e.pointerId)});gallery.addEventListener('pointermove',e=>{if(down)gallery.scrollLeft=sl-(e.clientX-x)});gallery.addEventListener('pointerup',()=>{down=false;index=Math.round(gallery.scrollLeft/gallery.clientWidth);go(index)});gallery.addEventListener('scroll',()=>{if(!down){const next=Math.round(gallery.scrollLeft/gallery.clientWidth);if(next!==index){index=Math.max(0,Math.min(slides.length-1,next));syncGalleryHeight(index)}thumbs.forEach((b,n)=>b.classList.toggle('is-active',n===index))}},{passive:true});
    slides.forEach((slide,n)=>{$('img',slide)?.addEventListener('load',()=>{if(n===index)syncGalleryHeight(index)},{once:true})});
    window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>syncGalleryHeight(index),100)});
    syncGalleryHeight(0);go(0)}

  // Quantity + product variant
  $$('[data-qty-plus]').forEach(b=>b.addEventListener('click',()=>{const i=$('[data-qty]',b.parentElement);if(i)i.value=Number(i.value||1)+1}));
  $$('[data-qty-minus]').forEach(b=>b.addEventListener('click',()=>{const i=$('[data-qty]',b.parentElement);if(i)i.value=Math.max(1,Number(i.value||1)-1)}));
  const variantSelect=$('[data-variant-select]');
  variantSelect?.addEventListener('change',()=>{const o=variantSelect.selectedOptions[0],id=$('[data-variant-id]'),add=$('[data-add-to-cart]'),buy=$('[data-buy-now]'),price=$('[data-product-price]');if(id)id.value=o.value;const available=o.dataset.available==='true';if(add){add.disabled=!available;add.textContent=available?'AGREGAR AL CARRITO':'AGOTADO'}if(buy)buy.disabled=!available;if(price){const compare=Number(o.dataset.compare||0),p=Number(o.dataset.price||0);price.innerHTML=money(p)+(compare>p?` <s>${money(compare)}</s>`:'')}});

  // Accordions sign
  $$('.product-accordions details').forEach(d=>d.addEventListener('toggle',()=>{const sign=$('summary span',d);if(sign)sign.textContent=d.open?'−':'+'}));

  // Cart drawer
  const drawer=$('[data-cart-drawer]'), backdrop=$('[data-cart-backdrop]');
  const closeCart=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');$$('[data-cart-open]').forEach(b=>b.setAttribute('aria-expanded','false'));if(backdrop)backdrop.hidden=true;lock(false)};
  const openCart=async()=>{if(!drawer)return;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');$$('[data-cart-open]').forEach(b=>b.setAttribute('aria-expanded','true'));if(backdrop)backdrop.hidden=false;lock(true);await renderCart()};
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));$('[data-cart-close]')?.addEventListener('click',closeCart);backdrop?.addEventListener('click',closeCart);
  async function getCart(){const r=await fetch(`${window.FMX.routes.cart}.js`,{headers:{Accept:'application/json'}});return r.json()}

  function recommendationUrl(source,page){const separator=source.includes('?')?'&':'?';return `${source}${separator}page=${page}`}
  function fetchRecommendationPage(source,page){
    if(!window.jQuery)return Promise.reject(new Error('jquery'));
    return new Promise((resolve,reject)=>{
      window.jQuery.ajax({url:recommendationUrl(source,page),method:'GET',dataType:'html',cache:true})
        .done(html=>{const shell=document.createElement('div');shell.innerHTML=html;resolve(shell.querySelector('[data-recommendation-page]'))})
        .fail(reject);
    });
  }

  let drawerRecommendationRun=0;
  async function renderDrawerRecommendations(cart){
    const root=$('[data-cart-recommendations]');if(!root)return;
    const track=$('[data-drawer-recommendation-track]',root),status=$('[data-drawer-recommendation-status]',root);
    if(!track)return;
    const run=++drawerRecommendationRun;
    if(!cart.items.length){root.hidden=true;track.innerHTML='';if(status)status.textContent='';return}
    const source=root.dataset.recommendationSource,limit=Math.max(2,Number(root.dataset.recommendationLimit||4));
    const excluded=new Set(cart.items.map(i=>String(i.product_id)));
    const cards=[];let pageNo=1,more=true;
    if(status)status.textContent='Cargando sugerencias…';
    try{
      while(cards.length<limit&&more&&pageNo<=8){
        const page=await fetchRecommendationPage(source,pageNo);
        if(run!==drawerRecommendationRun)return;
        if(!page){more=false;break}
        for(const card of Array.from(page.querySelectorAll('[data-product-id]'))){
          const id=String(card.dataset.productId||'');if(!id||excluded.has(id)||cards.some(c=>String(c.dataset.productId)===id))continue;
          card.classList.add('drawer-reco-product');cards.push(card);if(cards.length>=limit)break;
        }
        const next=Number(page.dataset.nextPage||0);more=next>pageNo;pageNo=more?next:pageNo+1;
      }
      if(run!==drawerRecommendationRun)return;
      track.innerHTML='';cards.forEach(card=>track.appendChild(card));root.hidden=cards.length===0;if(status)status.textContent='';
    }catch(e){root.hidden=true;track.innerHTML='';if(status)status.textContent=''}
  }

  async function renderCart(){if(!drawer)return;const c=await getCart();$$('[data-cart-count]').forEach(el=>el.textContent=c.item_count);const dc=$('[data-drawer-count]');if(dc)dc.textContent=`(${c.item_count})`;const sub=$('[data-cart-subtotal]');if(sub)sub.textContent=money(c.total_price);const items=$('[data-cart-items]');if(items)items.innerHTML=c.items.length?c.items.map((i,n)=>`<div class="drawer-item"><img src="${i.image||''}" alt=""><div><strong>${i.product_title}</strong><small>${i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:''}</small><span>${money(i.final_price)}</span><div class="drawer-item__qty"><button type="button" data-line-minus="${n+1}">−</button><span>${i.quantity}</span><button type="button" data-line-plus="${n+1}">+</button></div></div><button class="icon-btn" type="button" data-line-remove="${n+1}" aria-label="Eliminar">×</button></div>`).join(''):'<div class="empty-state"><p>Tu carrito está vacío.</p><a class="btn btn--primary" href="/collections/all">IR DE COMPRAS</a></div>';
    const threshold=Number(window.FMX.freeShipping||7500),remain=Math.max(0,threshold-c.total_price),text=$('[data-free-ship-text]'),prog=$('[data-free-ship-progress]');if(text)text.textContent=remain?`Te faltan ${money(remain)} para obtener envío GRATIS`:'¡Felicidades! Obtienes envío GRATIS';if(prog)prog.style.width=(threshold?Math.min(100,c.total_price/threshold*100):100)+'%';
    $$('[data-line-minus]').forEach(b=>b.onclick=()=>changeLine(Number(b.dataset.lineMinus),-1));$$('[data-line-plus]').forEach(b=>b.onclick=()=>changeLine(Number(b.dataset.linePlus),1));$$('[data-line-remove]').forEach(b=>b.onclick=()=>setLine(Number(b.dataset.lineRemove),0));
    renderDrawerRecommendations(c);}
  async function setLine(line,quantity){await fetch(window.FMX.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});await renderCart()}
  async function changeLine(line,delta){const c=await getCart(),item=c.items[line-1];if(item)await setLine(line,Math.max(0,item.quantity+delta))}
  const productForm=$('[data-product-form]');
  productForm?.addEventListener('submit',async e=>{e.preventDefault();try{const fd=new FormData(productForm),r=await fetch(`${window.FMX.routes.cartAdd}.js`,{method:'POST',headers:{Accept:'application/json'},body:fd});if(!r.ok)throw new Error('add');await openCart()}catch(err){alert('No se pudo agregar el producto al carrito.')}});
  $('[data-buy-now]')?.addEventListener('click',async()=>{if(!productForm)return;const fd=new FormData(productForm),r=await fetch(`${window.FMX.routes.cartAdd}.js`,{method:'POST',headers:{Accept:'application/json'},body:fd});if(r.ok)location.href='/checkout'});

  // Sort / mobile filters
  $('[data-sort-select]')?.addEventListener('change',e=>{const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);location.href=u.toString()});
  $('[data-filter-toggle]')?.addEventListener('click',()=>{const panel=$('[data-mobile-filters]');if(panel)panel.hidden=!panel.hidden});


  // Cart page recommendations: 4 visible desktop, 12 per AJAX batch, excludes products already in cart.
  const cartRecommendationRoot=$('[data-cart-page-recommendations]');
  if(cartRecommendationRoot){
    const track=$('[data-cart-page-recommendation-track]',cartRecommendationRoot),sentinel=$('[data-cart-recommendation-sentinel]',cartRecommendationRoot),status=$('[data-cart-recommendation-status]',cartRecommendationRoot);
    const source=cartRecommendationRoot.dataset.recommendationSource;
    const seen=new Set();let excluded=new Set(),nextPage=1,loading=false,exhausted=false,initializing=true;
    const setStatus=text=>{if(status)status.textContent=text||''};
    const updateCartRecoArrows=()=>{const count=$$('[data-product-id]',track).length;$$('[data-cart-recommendation-arrow]',cartRecommendationRoot).forEach(b=>b.hidden=count<=4)};
    const loadCartRecommendationBatch=async(target=12)=>{
      if(loading||exhausted||!source||!track||!sentinel)return;loading=true;cartRecommendationRoot.classList.add('is-loading');setStatus('Cargando productos…');let added=0;
      try{
        while(added<target&&!exhausted&&nextPage<=100){
          const page=await fetchRecommendationPage(source,nextPage);if(!page){exhausted=true;break}
          const cards=Array.from(page.querySelectorAll('[data-product-id]'));
          for(const card of cards){const id=String(card.dataset.productId||'');if(!id||excluded.has(id)||seen.has(id))continue;seen.add(id);card.classList.add('cart-reco-card');track.insertBefore(card,sentinel);added++;if(added>=target)break}
          const next=Number(page.dataset.nextPage||0);if(next>nextPage)nextPage=next;else exhausted=true;
          if(cards.length===0)exhausted=true;
        }
        if(seen.size>0)cartRecommendationRoot.hidden=false;updateCartRecoArrows();setStatus(exhausted?'Ya estás viendo todos los productos.':'');
      }catch(e){exhausted=true;setStatus('No se pudieron cargar más productos.')}finally{loading=false;initializing=false;cartRecommendationRoot.classList.remove('is-loading')}
    };
    getCart().then(c=>{excluded=new Set(c.items.map(i=>String(i.product_id)));loadCartRecommendationBatch(12)});
    if('IntersectionObserver' in window&&sentinel&&track){const obs=new IntersectionObserver(entries=>{if(!initializing&&entries.some(e=>e.isIntersecting))loadCartRecommendationBatch(12)},{root:track,rootMargin:'0px 700px 0px 0px',threshold:.01});obs.observe(sentinel)}
    const next=$('[data-carousel-next]',cartRecommendationRoot);next?.addEventListener('click',()=>{if(track&&track.scrollLeft+track.clientWidth>=track.scrollWidth-track.clientWidth*2)loadCartRecommendationBatch(12)});
  }

  // Product recommendations: 12 initially, then progressive AJAX batches through Shopify's collection alternate template.
  const recommendationRoot=$('[data-product-recommendations]');
  if(recommendationRoot){
    const track=$('[data-carousel-track]',recommendationRoot), sentinel=$('[data-recommendation-sentinel]',recommendationRoot), status=$('[data-recommendation-status]',recommendationRoot);
    const source=recommendationRoot.dataset.recommendationSource;
    const currentId=String(recommendationRoot.dataset.currentProductId||'');
    const seen=new Set($$('[data-product-id]',track).map(el=>String(el.dataset.productId)));
    let nextPage=1, loading=false, exhausted=false;

    const setStatus=text=>{if(status)status.textContent=text||''};
    const loadNextRecommendations=()=>{
      if(loading||exhausted||!source||!track||!sentinel)return;
      if(!window.jQuery){setStatus('No se pudo cargar más productos.');exhausted=true;return}
      loading=true;recommendationRoot.classList.add('is-loading');setStatus('Cargando más productos…');
      const separator=source.includes('?')?'&':'?';
      const url=`${source}${separator}page=${nextPage}`;
      window.jQuery.ajax({url,method:'GET',dataType:'html',cache:true})
        .done(html=>{
          const shell=document.createElement('div');shell.innerHTML=html;
          const page=shell.querySelector('[data-recommendation-page]');
          if(!page){exhausted=true;setStatus('');return}
          const cards=Array.from(page.querySelectorAll('[data-product-id]'));
          let appended=0;
          cards.forEach(card=>{
            const id=String(card.dataset.productId||'');
            if(!id||id===currentId||seen.has(id))return;
            seen.add(id);track.insertBefore(card,sentinel);appended++;
            if(seen.size>=4)recommendationRoot.classList.remove('product-recommendations--sparse');
            if(seen.size>4)$$('[data-recommendation-arrow]',recommendationRoot).forEach(b=>b.hidden=false);
          });
          const newNext=Number(page.dataset.nextPage||0);
          if(newNext>nextPage)nextPage=newNext;else exhausted=true;
          setStatus(exhausted?'Ya estás viendo todos los productos.':'');
          // A page can contain only duplicates from the initial related set; automatically continue until unique products appear or the catalog ends.
          if(appended===0&&!exhausted)setTimeout(loadNextRecommendations,40);
        })
        .fail(()=>{exhausted=true;setStatus('No se pudieron cargar más productos.');})
        .always(()=>{loading=false;recommendationRoot.classList.remove('is-loading')});
    };

    if('IntersectionObserver' in window&&sentinel&&track){
      const recommendationObserver=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting))loadNextRecommendations();
      },{root:track,rootMargin:'0px 700px 0px 0px',threshold:.01});
      recommendationObserver.observe(sentinel);
    }else if(track){
      track.addEventListener('scroll',()=>{
        if(track.scrollLeft+track.clientWidth>=track.scrollWidth-track.clientWidth*1.5)loadNextRecommendations();
      },{passive:true});
    }

    const nextButton=$('[data-carousel-next]',recommendationRoot);
    nextButton?.addEventListener('click',()=>{
      if(track&&track.scrollLeft+track.clientWidth>=track.scrollWidth-track.clientWidth*2)loadNextRecommendations();
    });
  }


  // BETA 4.7 — Responsive Home feeds.
  // Desktop: exactly four visible cards in a carousel, with progressive AJAX loading.
  // Mobile/tablet: no carousel; a static responsive grid with explicit AJAX "CARGAR MÁS".
  $$('[data-home-feed]').forEach(root=>{
    const track=$('[data-home-feed-track]',root);
    const prev=$('[data-home-feed-prev]',root);
    const next=$('[data-home-feed-next]',root);
    const more=$('[data-home-feed-more]',root);
    const status=$('[data-home-feed-status]',root);
    const source=root.dataset.feedSource||'';
    const total=Math.max(0,Number(root.dataset.feedTotal||0));
    if(!track||!source)return;

    const mobileQuery=window.matchMedia('(max-width:800px)');
    const seen=new Set($$('[data-feed-key]',track).map(card=>card.dataset.feedKey).filter(Boolean));
    let nextPage=1;
    let loading=false;
    let exhausted=total>0&&seen.size>=total;

    const setStatus=text=>{if(status)status.textContent=text||''};
    const isMobile=()=>mobileQuery.matches;
    const cards=()=>$$('[data-feed-key]',track);
    const cardStep=()=>{
      const first=cards()[0];
      if(!first)return Math.max(1,track.clientWidth/4);
      const styles=getComputedStyle(track);
      const gap=parseFloat(styles.columnGap||styles.gap||0)||0;
      return first.getBoundingClientRect().width+gap;
    };
    const atStart=()=>track.scrollLeft<=3;
    const atEnd=()=>track.scrollLeft+track.clientWidth>=track.scrollWidth-Math.max(4,cardStep()*.35);

    const updateControls=()=>{
      if(total>0&&seen.size>=total)exhausted=true;
      const mobile=isMobile();
      if(prev){prev.hidden=mobile;prev.disabled=atStart()}
      if(next){next.hidden=mobile;next.disabled=exhausted&&atEnd()}
      if(more)more.hidden=!mobile||exhausted;
      if(exhausted&&status)setStatus('');
    };

    const getPage=async pageNumber=>{
      const url=new URL(source,location.origin);
      url.searchParams.set('page',String(pageNumber));
      const response=await fetch(url.toString(),{headers:{Accept:'text/html'},credentials:'same-origin'});
      if(!response.ok)throw new Error('Home feed request failed');
      return response.text();
    };

    const loadNext=async()=>{
      if(loading||exhausted)return 0;
      loading=true;
      root.classList.add('is-loading');
      if(more){more.disabled=true;more.dataset.originalText=more.dataset.originalText||more.textContent;more.textContent='CARGANDO…'}
      setStatus('Cargando…');
      let totalAdded=0;
      try{
        // The first AJAX page can overlap the server-rendered initial 4/8 items.
        // Keep walking pages until unique cards are found or Shopify reports the end.
        let safety=0;
        while(!exhausted&&totalAdded===0&&safety<20){
          safety++;
          const html=await getPage(nextPage);
          const shell=document.createElement('div');shell.innerHTML=html;
          const page=shell.querySelector('[data-home-feed-page]');
          if(!page){exhausted=true;break}
          const incoming=Array.from(page.querySelectorAll('[data-feed-key]'));
          incoming.forEach(card=>{
            const key=card.dataset.feedKey||'';
            if(!key||seen.has(key))return;
            seen.add(key);
            track.append(card);
            totalAdded++;
          });
          const newNext=Number(page.dataset.nextPage||0);
          if(newNext>nextPage)nextPage=newNext;else exhausted=true;
          if(total>0&&seen.size>=total)exhausted=true;
        }
        setStatus('');
      }catch(e){
        setStatus('No se pudieron cargar más elementos.');
      }finally{
        loading=false;
        root.classList.remove('is-loading');
        if(more){more.disabled=false;more.textContent=more.dataset.originalText||'CARGAR MÁS'}
        updateControls();
      }
      return totalAdded;
    };

    prev?.addEventListener('click',()=>{
      track.scrollBy({left:-cardStep(),behavior:'smooth'});
    });
    next?.addEventListener('click',async()=>{
      if(atEnd()&&!exhausted)await loadNext();
      track.scrollBy({left:cardStep(),behavior:'smooth'});
    });
    more?.addEventListener('click',loadNext);

    let scrollTimer;
    track.addEventListener('scroll',()=>{
      clearTimeout(scrollTimer);
      scrollTimer=setTimeout(async()=>{
        updateControls();
        if(!isMobile()&&atEnd()&&!exhausted)await loadNext();
      },70);
    },{passive:true});

    mobileQuery.addEventListener?.('change',()=>{
      track.scrollLeft=0;
      updateControls();
    });
    updateControls();
  });

  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMenu();closeSearch();closeCart()}});
})();
